'use strict';

/**
 * 身份证，手机号隐藏中间部分
 * @param str
 * @param start [Number] 开始显示几位
 * @param end [Number] 结束显示几位
 * @param hidden [Number] 中间隐藏几位
 * @returns {string}
 */
module.exports = function (str) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  var hidden = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 11;

  if (!str) return "";
  return str.substr(0, start) + new Array(hidden).fill('*').join('') + str.substr(0 - end);
};